import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable()
export class ObservableService {

    private subject = new Subject<any>();
    private loadingToolSubject = new Subject<any>();

    hasChanged$ = this.subject.asObservable();
    lodingTools$ = this.loadingToolSubject.asObservable();

    onChange() {
        this.subject.next();
    }

    onToolLoading() {
        this.loadingToolSubject.next();
    }
}
